
import { defineComponent, ref, reactive } from 'vue';
import { useStore } from 'vuex';
import { POST_BROADCAST_SETTING, PUT_BROADCAST_SETTING } from '@/store/broadcast.module';
import Swal from 'sweetalert2';
import AppSelect from '@/components/input/AppSelect.vue';
import type { ApiErrorResponse, BroadcastScheduleInterval, BroadcastSetting, BroadcastSettingPayload } from '@/types/domain';

export default defineComponent({
  components: {
    AppSelect,
  },
  props: {
    title: { type: String, required: true },
    id: { type: Number, required: false },
    data: { type: Object, required: false, default: () => ({}) },
  },
  setup(props, { emit }) {
    const store = useStore();
    const isLoading = ref(false);
    const modalContent = ref(null);
    const initialData = props.data as Partial<BroadcastSetting>;

    const form = reactive<BroadcastSettingPayload>({
      name: initialData.name || '',
      jenisIuran: initialData.jenisIuran || '',
      scheduleInterval: initialData.scheduleInterval || '' as BroadcastScheduleInterval,
      scheduleDay: initialData.scheduleDay || 1,
      template: initialData.template || 'Halo {{name}}, ini adalah pengingat pembayaran {{jenisIuran}} IOM ITB. Mohon segera melunasi iuran Anda. Terima kasih.',
      isActive: initialData.isActive !== undefined ? initialData.isActive : true,
      recipients: initialData.recipients || [],
    });

    const closeModal = () => {
      emit('close');
    };

    const handleSubmit = async () => {
      const errors: string[] = [];
      if (!form.name.trim()) errors.push('Nama setting wajib diisi.');
      if (!form.jenisIuran.trim()) errors.push('Jenis iuran wajib diisi.');
      if (!form.scheduleInterval) errors.push('Interval wajib dipilih.');
      if (!form.scheduleDay || form.scheduleDay < 1) errors.push('Hari/tanggal tidak valid.');
      if (form.scheduleInterval === 'weekly' && form.scheduleDay > 7) errors.push('Hari harus antara 1-7.');
      if (['monthly', '3months'].includes(form.scheduleInterval) && form.scheduleDay > 31) errors.push('Tanggal harus antara 1-31.');
      if (!form.template.trim()) errors.push('Template pesan wajib diisi.');

      if (errors.length) {
        Swal.fire({
          title: 'Validasi',
          html: errors.join('<br>'),
          icon: 'warning',
          confirmButtonColor: '#003793',
        });
        return;
      }

      isLoading.value = true;
      try {
        if (props.id) {
          await store.dispatch(PUT_BROADCAST_SETTING, { id: props.id, data: { ...form } });
        } else {
          await store.dispatch(POST_BROADCAST_SETTING, { ...form });
        }
        closeModal();
      } catch (err: unknown) {
        const apiError = err as ApiErrorResponse;
        Swal.fire({
          title: 'Error',
          text: apiError?.response?.data?.message || apiError?.message || 'Terjadi kesalahan.',
          icon: 'error',
          confirmButtonColor: '#003793',
        });
        isLoading.value = false;
      }
    };

    return { form, isLoading, modalContent, closeModal, handleSubmit };
  },
});
